import { Empty, lucideIcons, Spinner } from '@round/creatorbase-ui';
import styles from './NextPageStatus.module.css';

const { AlertTriangle } = lucideIcons;

type Props = {
    isFetching: boolean;
    errorMessage: string | null;
    /** What failed to load, e.g. "Couldn't load more uploads". */
    errorTitle: string;
};

/** The spinner or the error for an infinite list's next page, rendered as the list's last row. */
const NextPageStatus = ({ isFetching, errorMessage, errorTitle }: Props) => {
    if (isFetching) {
        return (
            <div className={styles.fetchingMore}>
                <Spinner />
            </div>
        );
    }

    return (
        <Empty className={styles.error}>
            <Empty.Header className={styles.errorHeader}>
                <Empty.Media variant="icon" className={styles.errorIcon}>
                    <AlertTriangle />
                </Empty.Media>
                <Empty.Title>{errorTitle}</Empty.Title>
                <Empty.Description>{errorMessage || 'Scroll down again to retry.'}</Empty.Description>
            </Empty.Header>
        </Empty>
    );
};

export default NextPageStatus;
